import { render, staticRenderFns } from "./ProductSearch.vue?vue&type=template&id=5a3a474c&scoped=true"
import script from "./ProductSearch.vue?vue&type=script&lang=js"
export * from "./ProductSearch.vue?vue&type=script&lang=js"
import style0 from "./ProductSearch.vue?vue&type=style&index=0&id=5a3a474c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3a474c",
  null
  
)

export default component.exports